import { ACCESS_CARD, HOME_PAGE } from "services/apiURl";
import { commonHeaders, getRequest } from "services/httpHelper";

export const getHomePageAPI = async (orgid, eventid, options = {}) => {
  const { pagination, sorter, filters } = options;

  const baseUrl = `${HOME_PAGE}/orgs/${orgid}/events/${eventid}/albums/`;

  const params = new URLSearchParams();

  // Pagination
  params.append("page", pagination?.current || "1");
  params.append("page_size", pagination?.pageSize || "96");

  // Sorting
  let ordering = "-is_master,name";
  if (sorter) {
    const orderCol = sorter.field || "";
    const orderColWithOrder = sorter.order === "descend" ? `-${orderCol}` : orderCol;
    ordering = orderColWithOrder || ordering;
  }
  params.append("ordering", ordering);

  // Filters
  if (filters) {
    if (filters.albumId) {
      params.append("search_id__icontains", filters.albumId);
    }
    if (filters.albumName) {
      params.append("search_name__icontains", filters.albumName);
    }
    if (filters.albumIsDeleted !== undefined) {
      params.append("search_is_deleted__bool", filters.albumIsDeleted);
    }
  }

  const fullUrl = `${baseUrl}?${params.toString()}`;

  try {
    const response = await getRequest({
      url: fullUrl,
      headers: commonHeaders,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching home page data: ", error);
    return {};
  }
};


export const getHomeData = async () => {
  try {
    const response = await getRequest({
      url: ACCESS_CARD,
      headers: commonHeaders,
    });
    return response.data ? response.data : response;
  } catch (error) {
    console.error("Error fetching address data:", error);
    return null;
  }
};
